import { fetchWrapRPC } from '../services/api';
import {
  CalculateTokenUsageRequest,
  H2OGPTeService_CalculateTokenUsage,
} from './gen/ai/h2o/cloud/telemetry_read_api/h2ogpte/v1/h2ogpte_pb';
import {
  CalculateMaxUsageRequest,
  CalculateResourceUsageRequest,
  CalculateUsageRequest,
  ComponentService_ListComponents,
  GetQuotaRequest,
  ListComponentsRequest,
  QuotaService_GetQuota,
  UsageService_CalculateMaxUsage,
  UsageService_CalculateResourceUsage,
  UsageService_CalculateUsage,
} from './gen/ai/h2o/cloud/telemetry_read_api/v1/aiunits_pb';

// Run `npm run load-token` to update the token from the JSON file
const bearerToken = process.env.REACT_APP_BEARER_TOKEN || '';

export class TelemetryServiceImpl {
  private basePath: string;
  constructor(basePath?: string) {
    this.basePath = basePath || '';
  }

  public setBasePath = (path: string) => {
    this.basePath = path;
  };

  public async calculateMaxUsage(req: CalculateMaxUsageRequest) {
    return await fetchWrapRPC(UsageService_CalculateMaxUsage, { basePath: this.basePath })({ ...req });
  }

  public async calculateUsage(req: CalculateUsageRequest) {
    return await fetchWrapRPC(UsageService_CalculateUsage, { basePath: this.basePath })({ ...req });
  }

  public async calculateResourceUsage(req: CalculateResourceUsageRequest) {
    const options = bearerToken ? { basePath: this.basePath, bearerToken } : { basePath: this.basePath };
    return await fetchWrapRPC(UsageService_CalculateResourceUsage, options)({ ...req });
  }

  public async getQuota(req: GetQuotaRequest = {}) {
    return await fetchWrapRPC(QuotaService_GetQuota, { basePath: this.basePath })({ ...req });
  }

  public async listComponents(req: ListComponentsRequest = {}) {
    const options = bearerToken ? { basePath: this.basePath, bearerToken } : { basePath: this.basePath };
    return await fetchWrapRPC(ComponentService_ListComponents, options)({ ...req });
  }

  public async calculateTokenUsage(req: CalculateTokenUsageRequest) {
    const options = bearerToken ? { basePath: this.basePath, bearerToken } : { basePath: this.basePath };
    return await fetchWrapRPC(H2OGPTeService_CalculateTokenUsage, options)({ ...req });
  }
}
